import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { CookieSettingsLink } from "./CookieConsent";

/**
 * Imprint, privacy policy, terms and cookie settings, for pages outside the app shell.
 *
 * § 5 DDG wants the Impressum reachable from every page, and DSGVO Art. 7(3) wants
 * withdrawing consent to be as easy as giving it, so every page a visitor can reach
 * without an account carries this row. Inside the app the sidebar carries the same
 * links (components/Layout.jsx).
 */
export default function LegalLinks({ className = "", linkClassName = "hover:text-brand-600" }) {
  const { t } = useTranslation();
  return (
    <div className={`flex flex-wrap gap-x-4 gap-y-1 ${className}`} data-testid="legal-links">
      <Link to="/imprint" className={linkClassName}>{t("legal.imprint")}</Link>
      <Link to="/privacy" className={linkClassName}>{t("legal.privacy")}</Link>
      <Link to="/terms" className={linkClassName}>{t("legal.terms")}</Link>
      <CookieSettingsLink className={linkClassName} />
    </div>
  );
}
